<form [formGroup]="alimentatie">
    <div formArrayName="ontvangenAlimentatie">
        <div *ngFor="let alimentatie of ontvangenAlimentatie.controls; let i = index; "
                [formGroupName]="i" class="row">
            <div class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving alimentatie' : ''"
                                                class="custom-input-250"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedragAlimentatie"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijOntvangenAli(i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     class="col-auto"
                                     icon="trash"
                                     id="buttonDelete"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="ontvangenAlimentatie.length === 0">
        <snelstart-ui-button (click)="addRijOntvangenAli()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Ontvangen partneralimentatie invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="ontvangenAlimentatie.length > 0">
        <snelstart-ui-button (click)="addRijOntvangenAli()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Ontvangsten toevoegen
        </snelstart-ui-button>
    </div>

    <div formArrayName="aftrekbareKostenAlimentatie">
        <div *ngFor="let alimentatie of aftrekbareKostenAlimentatie.controls; let i = index; "
                [formGroupName]="i" class="row">
            <div class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                                class="custom-input-250"
                                                formControlName="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedragKosten"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button
                        (click)="verwijderRijKostenAli(i)"
                        [class]="i === 0 ? 'firstrowbutton' : ''"
                        class="col-auto"
                        icon="trash"
                        id="buttonDelete"
                        size="medium"
                        type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="aftrekbareKostenAlimentatie.length === 0">
        <snelstart-ui-button (click)="addRijKostenAli()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Kosten partneralimentatie invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="aftrekbareKostenAlimentatie.length > 0">
        <snelstart-ui-button (click)="addRijKostenAli()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Kosten toevoegen
        </snelstart-ui-button>
    </div>

</form>


